import { Controller } from "@hotwired/stimulus"

// Mirrors hover/focus between numbered pins on a mockup and their matching
// items in the callouts list. Mount on each `<section class="doc-section">`.
//
// Targets:
//   - pin:  each `.doc-mockup-pin`  (the rendered text "1", "2", … is the num)
//   - item: each `<li>` in `.doc-callouts`  (its 1-indexed position is the num)
export default class extends Controller {
  static targets = ["pin", "item"]

  connect() {
    this._bindings = []
    this._pinByNum = {}
    this._itemByNum = {}

    this.pinTargets.forEach(pin => {
      const num = parseInt((pin.textContent || "").trim(), 10)
      if (!num) return
      ;(this._pinByNum[num] ||= []).push(pin)
      this.bindPair(pin, num, false)
    })

    this.itemTargets.forEach((li, idx) => {
      const num = idx + 1
      this._itemByNum[num] = li
      this.bindPair(li, num, true)
    })
  }

  disconnect() {
    this._bindings.forEach(({ el, event, handler }) => {
      el.removeEventListener(event, handler)
    })
    this._bindings = []
  }

  bindPair(el, num, includeFocus) {
    const onEnter = () => this.setActive(num, true)
    const onLeave = () => this.setActive(num, false)
    this.addListener(el, "mouseenter", onEnter)
    this.addListener(el, "mouseleave", onLeave)
    if (includeFocus) {
      this.addListener(el, "focusin", onEnter)
      this.addListener(el, "focusout", onLeave)
    }
  }

  addListener(el, event, handler) {
    el.addEventListener(event, handler)
    this._bindings.push({ el, event, handler })
  }

  setActive(num, on) {
    ;(this._pinByNum[num] || []).forEach(p => p.classList.toggle("is-active", on))
    const li = this._itemByNum[num]
    if (li) li.classList.toggle("is-active", on)
  }
}
